<div class="chpw-page">

  <div class="page-header">
    <div class="page-header-text">
      <h2>{{ 'page.change_pw_title' | translate }}</h2>
      <p>{{ 'page.change_pw_subtitle' | translate }}</p>
    </div>
  </div>

  <div class="chpw-card app-card">
    <form [formGroup]="form" (ngSubmit)="submit()" class="chpw-form">

      <div class="form-group">
        <label for="currentPw">{{ 'lbl.current_password' | translate }}</label>
        <input
          formControlName="current_password"
          id="currentPw"
          type="password"
          class="form-control themed-input"
          placeholder="Enter your current password"
          autocomplete="current-password"
        />
        <span class="field-error" *ngIf="form.get('current_password')?.invalid && form.get('current_password')?.touched">
          {{ 'err.min8' | translate }}
        </span>
      </div>

      <div class="form-group">
        <label for="newPw">{{ 'lbl.new_password' | translate }}</label>
        <input
          formControlName="new_password"
          id="newPw"
          type="password"
          class="form-control themed-input"
          placeholder="Enter new password"
          autocomplete="new-password"
        />
        <span class="field-error" *ngIf="form.get('new_password')?.invalid && form.get('new_password')?.touched">
          {{ 'err.min8' | translate }}
        </span>
      </div>

      <div class="form-group">
        <label for="confirmPw">{{ 'lbl.confirm_password' | translate }}</label>
        <input
          formControlName="confirm_password"
          id="confirmPw"
          type="password"
          class="form-control themed-input"
          placeholder="Repeat new password"
          autocomplete="new-password"
        />
        <span class="field-error" *ngIf="form.errors?.['mismatch'] && form.get('confirm_password')?.touched">
          {{ 'err.password_mismatch' | translate }}
        </span>
      </div>

      <div class="form-actions">
        <button type="submit" class="save-btn" [disabled]="loading">
          <span class="material-symbols-outlined btn-icon" *ngIf="!loading">lock_reset</span>
          <span *ngIf="loading" class="btn-spinner"></span>
          {{ loading ? ('auth.saving' | translate) : ('btn.update_password' | translate) }}
        </button>
      </div>

    </form>
  </div>

</div>
